
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { CheckSquare } from 'lucide-react';
import { SignupFormConfig } from '@/schemas/signupFormSchema';

interface ValidationSettingsProps {
  formConfig: SignupFormConfig;
  setFormConfig: React.Dispatch<React.SetStateAction<SignupFormConfig>>;
}

const ValidationSettings: React.FC<ValidationSettingsProps> = ({ formConfig, setFormConfig }) => {
  const handleAccountNumberChange = (checked: boolean) => {
    setFormConfig(prev => ({ ...prev, validateAccountNumber: checked }));
  };

  const handleLicenseNumberChange = (checked: boolean) => {
    setFormConfig(prev => ({ ...prev, validateLicenseNumber: checked }));
  };

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center gap-2 mb-4">
          <CheckSquare className="h-5 w-5 text-primary" />
          <h3 className="text-lg font-medium">Validation Settings</h3>
        </div>
        
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <Switch
              id="validateAccountNumber"
              checked={formConfig.validateAccountNumber}
              onCheckedChange={handleAccountNumberChange}
            />
            <Label htmlFor="validateAccountNumber">Validate Account Number</Label>
          </div>
          
          <div className="flex items-center space-x-2">
            <Switch
              id="validateLicenseNumber"
              checked={formConfig.validateLicenseNumber}
              onCheckedChange={handleLicenseNumberChange}
            />
            <Label htmlFor="validateLicenseNumber">Validate License Number</Label>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ValidationSettings;
